"use strict";

(function (global) {

   /**
  * Фабрика записей справочников.
  * Предоставлет инструменты для работы с записями справочников. Например, для открытия справочника, для создания новой записи.
  *
  * @namespace WebAccess.factories.references
  * @property {OBJECT_TYPE} WebAccess.factories.references.contentType Тип содержимого фабрики
  * @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED – заданы не все обязательные параметры.
   * @since 5.0.0.7300
   */


  /**
   * Параметры создаваемой задачи.
  *
   * @typedef {Object} WebAccess.factories.references.referenceRecordSettings
   * @property {Object} [environmentVars] Тема задачи
   * @property {Object} [paramVars] Текст задачи
   * @property {Object} [ourFirmID] ИД нашей организации
   * @property {boolean} [autoSave] Признак сохранения задачи после ее создания
   * @property {WA.Link} [bindTo] Создание связи с объектом
  * @since 5.0.0.7300
  */

  var ReferenceFactory = global.factories.BaseFactory.extend({
      className: "ReferenceFactory",
      referenceName: '',


      contentType: OBJECT_TYPE.REFERENCE_RECORD,
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      init: function (referenceName) {
        if (!referenceName) {
          WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'referenceName');
        };

        this.referenceName = referenceName;
        this._super(this.contentType);
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Получить задачу по ее ИД.
      *
      * @method WebAccess.factories.tasks.getRecordByID
      * @param {Integer} id ИД карточки задачи
      * @param {MODEL} opt_modelType Тип возвращаемой модели данных
      * @return {deferred} Искомая задача.
      * @since 5.0.0.7300
      */
      getRecordByID: function (id, opt_modelType) {
        return this.getObjectByID(id, opt_modelType);
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Формирует объект WebAccess.URL с URL-адресом формы-списка справочника.
      *
      * @method WebAccess.factories.references.toURL
      * @return {WebAccess.URL} URL-адрес справочника.
      *
      * @example <caption>Сформировать URL-адрес справочника «Работники».</caption>
      * WebAccess.factories.references('РАБ').toURL();
      * @since 5.4.0.1013
      */
      toURL: function() {
        return new WA.URL("/ReferenceRecords.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&mode=RefRecords&compcode=" + this.referenceName + "&toolitem=Run");
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Открыть справочник.
      *
      * @method WebAccess.factories.references.open
      * @return {WebAccess.factories.references} Список записей указанного справочника.
      *
      * @example <caption>Открыть список записей справочника «Работники» в проводнике веб-доступа.</caption>
      * WebAccess.factories.references('РАБ').open();
      * @since 5.0.0.7300
      */
      open: function () {
        this.toURL().open();
        return this;
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Открывает справочник в модальном окне.
      *
      * @method WebAccess.factories.references.openInModal
      * @return {WebAccess.factories.references} Список записей указанного справочника.
      *
      * @example <caption>Открыть справочник «Работники» в модальном окне в режиме множественного выбора.</caption>
      * WebAccess.factories.references('РАБ').openInModal({mode: REFERENCE_MODAL_MODE.MULTI});
      * @since 5.4.0.1013
      */
      openInModal: function(settings) {
        var me = this;
        var newSettings = $.extend({}, settings, {
          referenceName: me.referenceName
        });
        WebAccess.components.dialogs.ReferenceGridDialog.createAndShow(newSettings);
        return this;
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
       * Создать записи справочника.
       *
       * @method WebAccess.factories.references.createRecord
       * @param {Object | WebAccess.factories.references.referenceRecordSettings} [opt_environmentVars] Перемнные окружения
       * @param {number} [opt_ourFirmID] ИД нашей организации
       * @param {Object} [opt_paramVars] Параметры записи справочника
       * @param {MODEL} [opt_modelType] Тип возвращаемой модели данных
       * @return {Deferred<Object>} Запись справочника.
       * @since 5.0.0.7300
       * @see https://api.jquery.com/category/deferred-object/
       *
       * @example <caption>Создать новую запись в справочнике «Работники» и затем открыть ее.</caption>
       * WebAccess.factories.references("РАБ").createRecord(null, 38838).done(function(record) {
       *   record.open();
       * });
       *
       * @example <caption>Создать новую запись в справочнике «Работники» и заполнить ее реквизиты.</caption>
       * WebAccess.factories.references('РАБ') .createRecord({
       *  ourFirmID: 38838,
       *  requisites: {
       *    'Примечание': 'Запись, созданная фабрикой'
       *  }}).done(function (record) {
       *    record.open();
       *  });
       */
      createRecord: function (opt_environmentVars, opt_ourFirmID, opt_paramVars, opt_modelType) {
        var me = this;
        var proxyCall = $.Deferred();
        opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;

        var envVars;
        var ourFirmID;
        var paramVars;
        var query = {};

        if ($.isPlainObject(opt_environmentVars)) {
          query = opt_environmentVars;

          if (opt_environmentVars.hasOwnProperty('environmentVars')) {
            query.envVars = $.toJSON(opt_environmentVars.environmentVars);
          };

          if (opt_environmentVars.hasOwnProperty('paramVars')) {
            query.paramVars = $.toJSON(opt_environmentVars.paramVars);
          };

          if (opt_environmentVars.hasOwnProperty('requisites')) {
            query.requisites = $.toJSON(opt_environmentVars.requisites);
          };

          if (opt_environmentVars.hasOwnProperty('bindTo')) {
            query.bindTo = opt_environmentVars.bindTo.asString();
          }

        } else {
          query.envVars = opt_environmentVars;
          query.ourFirmID = opt_ourFirmID;
          query.paramVars = paramVars
        };

        WA.SRV.call("/Factories.asmx/CreatePreConfiguredRecord", {
          ReferenceName: this.referenceName,
          Params: query,
          Mode: opt_modelType
        }).done(function (model) {
          proxyCall.resolve(me._handleModel(model, opt_modelType));
        }).fail(function(error) {
          proxyCall.reject(error);
        });
        return proxyCall;
      }
    });
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.references = function (referenceName) {
    return new ReferenceFactory(referenceName);
  };
  
  /**
   * Открыть справочник.
   *
   * @global
   * @function WebAccess.factories.references.openReference
   * @param {object} referenceModel Модель справочника.
   * @param {bool} [opt_isModal] Признак открытия справочника в модальном окне.
   */
  global.factories.references.openReference = (referenceModel, opt_isModal) => {
    // В случае, если opt_isModal = undefined, то в opt_isModal запишется false.
    opt_isModal = opt_isModal === true;

    let reference = WA.FC.references(referenceModel.componentCode);
    if(opt_isModal) {
      reference.openInModal({
        instanceId: referenceModel.instanceId,
        mode: REFERENCE_MODAL_MODE.VIEW
      });
    } else {
      let url = reference.toURL();
      url.setParam('uid', referenceModel.instanceId);
      url.open();
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);